<template>
  <table-index
    :config="tableConfig"
  >
    <template
      #dynamic-content
    >
      <vehicle-reservation-dialog
        v-if="vehicleReservationDialogConfig.show"
        :show-dialog="vehicleReservationDialogConfig.show"
        :is-admin="vehicleReservationDialogConfig.isAdmin"
        :vehicle-id="vehicleReservationDialogConfig.vehicleId"
        :registration="vehicleReservationDialogConfig.registration"
        @close="onCloseVehicleReservationDialog"
      />
    </template>
  </table-index>
</template>

<script>
import TableIndex from '@/global/components/table/TableIndex.vue'
import DateHeaderWithArrows from '../components/DateHeaderWithArrows.vue'
import CellCircle from '../components/CellCircle.vue'
import { api } from '@/global/services/api'
import VehicleReservationDialog from '../components/VehicleReservationDialog.vue'
import TableVehicleReservationActionButton from '../components/TableVehicleReservationActionButton.vue'
import ReservationStatusLegend from '../components/ReservationStatusLegend.vue'

const DAYS_BEFORE = 7
const DAYS_AFTER = 8
const DEFAULT_SUBHEADER_WIDTH_IN_PX = 70
export default {
  name: 'VehicleReservationOverview',

  components: {
    VehicleReservationDialog,
    TableIndex
  },

  data () {
    return {
      dayOffset: 0,
      dateHeaders: [],
      daysToShow: null,
      baseHeaders: [
        {
          label: this.$t('fleet/vehicle.registration'),
          key: 'registration',
          style: {
            width: '140px',
            borderRight: '1px solid #D1D5DB',
            borderBottom: '1px solid #D1D5DB'
          },
          always_visible: true
        },
        {
          label: this.$t('fleet/vehicle.label'),
          key: 'label',
          style: {
            width: '130px',
            borderRight: '1px solid #D1D5DB',
            borderBottom: '1px solid #D1D5DB'
          },
          always_visible: true
        },
        {
          key: 'calendar',
          onResize: async (event) => {
            const { headerRef } = event || {}

            if (headerRef && headerRef[0]) {
              const { clientWidth } = headerRef[0]

              if (clientWidth) {
                const columnsNumber = parseInt(clientWidth / DEFAULT_SUBHEADER_WIDTH_IN_PX)
                this.daysToShow = columnsNumber
                this.daysBefore = Math.floor((columnsNumber - 1) / 2)
                this.daysAfter = columnsNumber - 1 - this.daysBefore
                this.populateDateHeaders()
              }
            }
          },
          style: {
            width: '100%',
            height: '60px',
            borderBottom: '1px solid #D1D5DB'
          },
          component: DateHeaderWithArrows,
          onPrevious: (type) => this.goBack(type),
          onNext: (type) => this.goForward(type),
          subHeaders: [],
          always_visible: true
        }
      ],
      startDate: null,
      endDate: null,
      vehicleReservationDialogConfig: {
        show: false,
        isAdmin: false,
        vehicleId: null,
        registration: ''
      },
      showLoader: false,
      vehicleIds: '',
      dayDuration: null,
      tableData: null,
      existingTableData: [],
      isAdmin: false,
      showMyReservations: false,
      daysBefore: DAYS_BEFORE,
      daysAfter: DAYS_AFTER
    }
  },

  computed: {
    tableConfig () {
      return {
        tableConfig: {
          apiConfig: {
            get: {
              module: 'fleet',
              route: 'vehicle-reservations/vehicles',
              method: 'get'
            }
          },
          showLoader: this.showLoader,
          tableData: this.tableData,
          onDataReceived: (event) => this.onTableDataReceived(event),
          onOpenReservationDialog: (event) => this.onVehicleReservation(event),
          rowClick: (event) => this.onRowClick(event),
          underFiltersCustomComponents: [
            {
              component: ReservationStatusLegend
            }
          ],
          tableConfig: {
            globalConfig: {
              dayDuration: this.dayDuration,
              daysToShow: this.daysToShow,
              fillEmptySpace: false,
              stripeRowsConfig: {
                oddNumbers: true,
                style: {
                  backgroundColor: '#f6f6f6'
                }
              }
            },
            styles: {
              useFixedHeaderWidth: true,
              headersHeight: '76px',
              dataRowHeight: '64px',
              globalCellsStyle: {
                textAlign: 'center',
                padding: 'unset !important'
              },
              globalHeaderStyle: {
                textAlign: 'center',
                padding: 'unset !important'
              }
            },
            headers: this.baseHeaders,
            actionsTitle: 'Rezerviraj',
            actionCustom: {
              component: TableVehicleReservationActionButton
            },
            filtersConfig: {
              fields: [
                {
                  key: 'vehicle_id',
                  label: 'Odaberite vozilo',
                  type: 'autocomplete',
                  autocomplete_options: {
                    module: 'fleet',
                    route: 'vehicles/autocomplete'
                  }
                }
              ]
            },
            paginationConfig: {
              perPageOptions: [20, 50, 100]
            }
          }
        },
        breadcrumbs: {
          items: [
            {
              text: this.$t('fleet.vehicles_reservation')
            },
            {
              text: this.$t('fleet/vehicle_reservation.reservations_overview'),
              bolded: true
            }
          ]
        }
      }
    }
  },

  created () {
    this.populateDateHeaders()
  },

  methods: {
    populateDateHeaders () {
      const today = new Date()
      this.baseHeaders[2].subHeaders.splice(0, this.baseHeaders[2].subHeaders.length)

      for (let i = -this.daysBefore + this.dayOffset; i <= this.daysAfter + this.dayOffset; i++) {
        const currentDate = new Date(today)
        currentDate.setDate(today.getDate() + i)

        const monthAndYear = `${String(currentDate.getMonth() + 1).padStart(2, '0')}/${String(currentDate.getFullYear()).slice(-2)}.`
        let label = '-'

        if (i === 0) {
          label = '<b>(Danas)</b>' + '<br>' + `${currentDate.getDate().toString().padStart(2, '0')}.`
        }
        else {
          label = '(' + monthAndYear + ')' + '<br>' + `${currentDate.getDate().toString().padStart(2, '0')}.`
        }

        this.baseHeaders[2].subHeaders.push({
          label,
          key: currentDate.getFullYear() + '-' +
            String(currentDate.getMonth() + 1).padStart(2, '0') + '-' +
            String(currentDate.getDate()).padStart(2, '0'),
          style: {
            height: '60px',
            textAlign: 'center',
            minWidth: DEFAULT_SUBHEADER_WIDTH_IN_PX + 'px'
          },
          component: CellCircle,
          color: null
        })
      }
    },

    async goBack (type) {
      if (type === 'day') {
        this.dayOffset -= 1
      }
      else if (type === 'week') {
        this.dayOffset -= 7
      }
      else if (type === 'month') {
        this.dayOffset -= 30
      }

      this.populateDateHeaders()
      await this.fetchReservationsAndPopulateHeaders()
    },

    async goForward (type) {
      if (type === 'day') {
        this.dayOffset += 1
      }
      else if (type === 'week') {
        this.dayOffset += 7
      }
      else if (type === 'month') {
        this.dayOffset += 30
      }

      this.populateDateHeaders()
      await this.fetchReservationsAndPopulateHeaders()
    },

    async onTableDataReceived (event) {
      const { dayDuration } = event?.meta?.config || {}
      const { isAdmin } = event?.meta?.permissions || {}
      const { data } = event || {}
      this.dayDuration = dayDuration || null
      this.isAdmin = isAdmin

      if (data && data.length) {
        this.existingTableData = data
        this.vehicleIds = data.map(item => item.id).join(',')
      }
      else {
        this.vehicleIds = ''
      }

      if (this.vehicleIds) {
        await this.fetchReservationsAndPopulateHeaders()
      }
    },

    async onCloseVehicleReservationDialog (refreshCalendar = false) {
      this.$set(this.vehicleReservationDialogConfig, 'show', false)

      if (refreshCalendar) {
        await this.fetchReservationsAndPopulateHeaders()
      }
    },

    onVehicleReservation (event) {
      const { id: vehicleId, registration } = event?.data || {}

      if (!vehicleId) return

      this.$set(this.vehicleReservationDialogConfig, 'show', true)
      this.$set(this.vehicleReservationDialogConfig, 'isAdmin', this.isAdmin)
      this.$set(this.vehicleReservationDialogConfig, 'vehicleId', vehicleId)
      this.$set(this.vehicleReservationDialogConfig, 'registration', registration)
    },

    onRowClick (event) {
      const { id: vehicleId } = event?.data || {}

      if (vehicleId) {
        this.$router.push({
          name: 'VehicleReservationHistory',
          query: {
            vehicleId: vehicleId
          }
        }).then()
      }
    },

    async fetchReservationsAndPopulateHeaders () {
      try {
        this.showLoader = true
        const today = new Date()

        const startDate = new Date(today)
        startDate.setDate(today.getDate() - this.daysBefore + this.dayOffset)

        const endDate = new Date(today)
        endDate.setDate(today.getDate() + this.daysAfter + this.dayOffset)

        const formatDate = (date) => {
          return date.toISOString().split('T')[0] // 'YYYY-MM-DD'
        }

        this.startDate = formatDate(startDate)
        this.endDate = formatDate(endDate)

        // On first page load, fetch vehicle reservations for default last 30 days (daysBefore days before now and daysAfter days after now)
        const { data: vehiclesReservations } = await api('fleet').get('vehicle-reservations', {
          date_start: this.startDate,
          date_end: this.endDate,
          vehicles: this.vehicleIds,
          showMyReservations: this.showMyReservations
        })

        if (this.existingTableData.length && vehiclesReservations) {
          const newTableData = [...this.existingTableData]
          this.existingTableData.forEach((vehicle, index) => {
            const { id: vehicleId } = vehicle || {}

            if (vehicleId && vehiclesReservations[vehicleId]) {
              newTableData[index] = {
                ...newTableData[index],
                ...vehiclesReservations[vehicleId]
              }
            }
          })

          this.tableData = [...newTableData]
        }

        this.showLoader = false
      }
      catch (exception) {
        this.showLoader = false
        console.error(exception)
      }
    }
  }
}
</script>
